import { CommonModule } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { CommonService } from 'src/app/core/services/common.service';
import { PlanService } from 'src/app/core/services/plan.service';
import { PlanCategoryService } from 'src/app/core/services/plan-category.service';
import { CustomButtonDto } from 'src/app/shared/components/app-button/app-button-dto';
import { AppButtonComponent } from 'src/app/shared/components/app-button/app-button.component';
import { CarouselPlansComponent } from 'src/app/shared/components/carousel-plans/carousel-plans.component';
import { ModalPlanSelectionComponent } from 'src/app/shared/components/modal-plan-selection/modal-plan-selection.component';
import { PeriodicitiModel, Plan } from 'src/app/shared/models/planModel';
import { PlanCategory, PlanSimple } from 'src/app/shared/models/planCategoryModel';
import { StyleContentPlan } from 'src/app/shared/models/styleContent';
import { CustomCurrencyPipe } from 'src/app/shared/pipe/custom-currency.pipe';
import { LayoutConfigService } from 'src/app/shared/services/layout-config.service';

interface CarouselItem {
  title: string;
  enableItems: string[];
  disableItems: string[];
  highlight: boolean;
  periodo: string;
  valor: string;
  src: string;
  buttonOptions: CustomButtonDto;
  planId?: string;
  planCategoryId?: string;
}

@Component({
  selector: 'app-section-planos',
  standalone: true,
  imports: [CommonModule, CarouselPlansComponent, ModalPlanSelectionComponent],
  templateUrl: './section-planos.component.html',
  styleUrls: ['./section-planos.component.scss']
})
export class sectionPlanosComponente implements OnInit {

  buttonOptionsCard = {
    primaryColor: '#191844',
    secondaryColor: '#191844',
    buttonText: 'ME TORNAR SÓCIO',
    buttonTextColor: '#ffffff',
    borderRadius: '25px',
    buttonBorderWidth: 'none',
    buttonBorderColor: 'none',
    buttonSize: 'btn btn-md',
    fontSize: 12
  };

  buttonOptionsCardSpecial = {
    primaryColor: '#191844',
    secondaryColor: '#191844',
    buttonText: 'ME TORNAR SÓCIO',
    buttonTextColor: '#ffffff',
    borderRadius: '25px',
    buttonBorderWidth: 'none',
    buttonBorderColor: 'none',
    buttonSize: 'btn btn-md',
    fontSize: 12
  };

  title = '';
  subtitle = '';
  showSubtitle = false;

  isMobile = window.innerWidth < 768;
  items: CarouselItem[] = [];
  classes: any;
  classesAlign: any;
  currencyPipe = new CustomCurrencyPipe();

  public styles: { [key: string]: any };

  // Modal properties
  showModal = false;
  planCategories: PlanCategory[] = [];
  modalCategories: PlanCategory[] = [];
  selectedCategoryIndex = 0;
  fullPlans: Plan[] = [];

  constructor(
    private layoutConfigService: LayoutConfigService,
    private planService: PlanService,
    private planCategoryService: PlanCategoryService,
    private commonService: CommonService,
    private router: Router
  ) { }


  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobile = (event.target as Window).innerWidth < 768;
  }

  ngOnInit(): void {
    const layoutVersion = this.layoutConfigService.getLayoutVersion();
    this.classes = {
      'layout-v2': layoutVersion === 2,
    };
    this.classesAlign = {
      'align-items-center': layoutVersion === 1,
      'align-items-start': layoutVersion === 2
    };

    // Comentado temporariamente até a rota pública ser liberada no backend
    this.loadPlanCategories();
    this.getPlanConfig();

  }


  getAllPlans() {
    this.planService.getPublicPlans().subscribe((plans: any) => {
      // Armazenar TODOS os planos completos para usar no modal (incluindo showOnPortal = false)
      const allPublicPlans = plans.content
        .filter((plan: Plan) => !!plan.saleLocations.find(location => location.name === 'Site'));
      
      this.fullPlans = allPublicPlans;
      
      // Filtrar apenas os planos que devem aparecer no carrossel (showOnPortal = true)
      const plansForCarousel = allPublicPlans
        .filter((plan: Plan) => plan.showOnPortal === true);
      
      this.items = plansForCarousel
        .map((plan: Plan) => {
          const planCategory = this.findPlanCategory(plan.id);
          return {
            title: plan.planName,
            enableItems: plan.benefits
              ?.filter(benefit => benefit.isActive)
              .sort((a: any, b: any) => a.order - b.order)
              .map(benefit => benefit.benefitName) as string[],
            disableItems: plan.benefits
              ?.filter(benefit => !benefit.isActive)
              .map(benefit => benefit.benefitName) as string[],
            periodo: plan.periodicities.map((period: PeriodicitiModel) => period.description).join(', '),
            valor: plan.amount === 0 || plan.amount === null
              ? 'Gratuito'
              : `${this.currencyPipe.transform(plan.amount)}/mês`,
            src: this.commonService.getImageStr(plan.imgPortalPlan?.id as string),
            highlight: plan.highlightOnPortal ?? false,
            buttonOptions: plan.highlightOnPortal ? this.buttonOptionsCard : this.buttonOptionsCardSpecial,
            position: plan.position,
            planId: plan.id,
            planCategoryId: planCategory?.id
          };
        });
      this.items.sort((a: any, b: any) => a.position - b.position);
    });
  }



  getPlanConfig() {
    this.planService.getPlanConfig().subscribe((config: StyleContentPlan) => {
      const styleContent = config;

      this.setStyles(styleContent);
      this.setBtnStyle(styleContent);
      this.getAllPlans();
    });
  }

  setStyles(styles: StyleContentPlan) {
    this.title = styles.title;
    this.subtitle = styles.subtitle;
    this.showSubtitle = styles.showSubtitle;
    this.styles = {
      carouselType: styles.carouselType,
      carouselInterval: styles.carouselInterval,
      '--show-section': styles.showSection ? 'flex' : 'none',
      '--show-subtitle': styles.showSubtitle ? 'block' : 'none',
      '--title-size': this.commonService.getRemFontSize(styles.titleSize, this.isMobile),
      '--title-color': styles.titleColor,
      '--subtitle-size': this.commonService.getRemFontSize(styles.subtitleSize, this.isMobile),
      '--subtitle-color': styles.subtitleColor,
      '--background-general-color': styles.backgroundGeneralColor,
      '--background-general-image': styles.backgroundGeneralType == 'IMAGE' ? `url(${this.commonService.getImageStr(styles.backgrounGeneralImage?.id)})` : 'none',

      '--card-default-title-size': this.commonService.getRemFontSize(styles.cardDefaultTitleSize, false),
      '--card-default-title-color': styles.cardDefaultTitleColor,
      '--card-default-description-size': this.commonService.getRemFontSize(styles.cardDefaultDescriptionSize, false),
      '--card-default-description-color': styles.cardDefaultDescriptionColor,
      '--card-default-price-size': this.commonService.getRemFontSize(styles.cardDefaultPriceSize, false),
      '--card-default-price-color': styles.cardDefaultPriceColor,
      '--card-default-background-color': styles.cardDefaultBackgroundColor,
      '--card-default-background-image': styles.cardDefaultBackgroundType == 'IMAGE' ? `url(${this.commonService.getImageStr(styles.cardDefaultBackgroundImage?.id)})` : 'none',

      '--card-special-title-size': this.commonService.getRemFontSize(styles.cardSpecialTitleSize, false),
      '--card-special-title-color': styles.cardSpecialTitleColor,
      '--card-special-description-size': this.commonService.getRemFontSize(styles.cardSpecialDescriptionSize, false),
      '--card-special-description-color': styles.cardSpecialDescriptionColor,
      '--card-special-price-size': this.commonService.getRemFontSize(styles.cardSpecialPriceSize, false),
      '--card-special-price-color': styles.cardSpecialPriceColor,
      '--card-special-background-color': styles.cardSpecialBackgroundColor,
      '--card-special-background-image': styles.cardSpecialBackgroundType == 'IMAGE' ? `url(${this.commonService.getImageStr(styles.cardSpecialBackgroundImage?.id)})` : 'none',

      '--side-buttons-color': styles.sideButtonsColor,
      '--side-buttons-border-color': styles.sideButtonsBorderColor,
      '--side-buttons-border': styles.sideButtonsBorder ? '1px solid' : 'none',
      '--side-buttons-icon-color': styles.sideButtonsColor
    }
  }



  private setBtnStyle(styles: StyleContentPlan) {
    this.buttonOptionsCard = {
      primaryColor: styles.cardDefaultButtonColor,
      secondaryColor: styles.cardDefaultButtonColor,
      buttonText: styles.cardDefaultButtonText,
      buttonTextColor: styles.cardDefaultButtonTextColor,
      borderRadius: '25px',
      buttonBorderWidth: styles.cardDefaultButtonHasBorder ? '1px' : 'none',
      buttonBorderColor: styles.cardDefaultButtonBorderColor,
      buttonSize: 'btn btn-md',
      fontSize: 12,
    }

    this.buttonOptionsCardSpecial = {
      primaryColor: styles.cardSpecialButtonColor,
      secondaryColor: styles.cardSpecialButtonColor,
      buttonText: styles.cardSpecialButtonText,
      buttonTextColor: styles.cardSpecialButtonTextColor,
      borderRadius: '25px',
      buttonBorderWidth: styles.cardSpecialButtonHasBorder ? '1px' : 'none',
      buttonBorderColor: styles.cardSpecialButtonBorderColor,
      buttonSize: 'btn btn-md',
      fontSize: 12,
    }
  }

  carouselResponse(event: any) {
    const selectedItem = this.items.find(item => item.title === event.title);
    
    if (!selectedItem) {
      return;
    }

    // Verificar se o plano pertence a alguma categoria retornada pela API
    if (selectedItem.planCategoryId) {
      const category = this.planCategories.find(cat => cat.id === selectedItem.planCategoryId);
      if (category && category.plans && category.plans.length > 0) {
        // Preparar todas as categorias com planos completos para o modal
        this.modalCategories = this.planCategories
          .filter(cat => cat.plans && cat.plans.length > 0)
          .map(cat => {
            const fullPlans = cat.plans
              .map(planSimple => {
                // Buscar o plano completo primeiro (pode estar ou não no carrossel)
                const fullPlan = this.findFullPlanById(planSimple.id);
                
                // Se não encontrar, pular (não deveria acontecer se API estiver consistente)
                if (!fullPlan) return null;
                
                // Buscar dados do carrossel se existir
                const fullPlanItem = this.items.find(item => item.planId === planSimple.id);
                
                // Criar objeto do plano para o modal
                return {
                  id: planSimple.id,
                  name: planSimple.name,
                  planName: planSimple.name,
                  amount: fullPlan.amount || 0,
                  imgPortalPlan: fullPlan.imgPortalPlan,
                  description: fullPlan.periodicities?.map((p: any) => p.description).join(', ') || '',
                  benefits: fullPlan.benefits || [],
                  showOnPortal: fullPlan.showOnPortal
                };
              })
              .filter(plan => plan !== null);

            return {
              ...cat,
              plans: fullPlans as any[]
            };
          })
          .filter(cat => cat.plans.length > 0);

        if (this.modalCategories.length > 0) {
          // Encontrar o índice da categoria do plano selecionado
          this.selectedCategoryIndex = this.modalCategories.findIndex(cat => cat.id === selectedItem.planCategoryId);
          if (this.selectedCategoryIndex === -1) {
            this.selectedCategoryIndex = 0;
          }
          
          this.showModal = true;
          return;
        }
      }
    }
    
    // Se não encontrou categoria ou categoria não tem planos, ir direto para cadastro
    this.router.navigateByUrl('/cadastro-socio');
  }

  private extractAmountFromString(valorString: string): number {
    if (valorString === 'Gratuito') {
      return 0;
    }
    const match = valorString.match(/R\$\s*([\d.,]+)/);
    if (match) {
      return parseFloat(match[1].replace('.', '').replace(',', '.'));
    }
    return 0;
  }

  private extractImageId(src: string): string {
    // Extrai o ID da imagem da URL (último segmento)
    const parts = src.split('/');
    return parts[parts.length - 1] || '';
  }

  loadPlanCategories() {
    this.planCategoryService.getAll(0, 100).subscribe({
      next: (response: any) => {
        // A API pode retornar array direto ou objeto paginado
        this.planCategories = Array.isArray(response) ? response : (response.content || []);
        console.log('Categorias de planos carregadas:', this.planCategories);
      },
      error: (error) => {
        // Se der erro ao carregar categorias (ex: 403), continua sem categorias
        console.warn('Não foi possível carregar as categorias de planos:', error);
        this.planCategories = [];
      }
    });
  }

  findPlanCategory(planId: string): PlanCategory | undefined {
    return this.planCategories.find(category => 
      category.plans?.some(plan => plan.id === planId)
    );
  }

  findFullPlanById(planId: string): Plan | undefined {
    return this.fullPlans.find(plan => plan.id === planId);
  }

  onCloseModal() {
    this.showModal = false;
    this.modalCategories = [];
  }

  onSelectPlan(planId: string) {
    this.showModal = false;
    this.modalCategories = [];
    // Redirecionar para cadastro com o planId selecionado
    this.router.navigateByUrl(`/cadastro-socio?planId=${planId}`);
  }


}
